// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.linked-cases-table-container {
  margin: 2rem 0;
  overflow-x: auto;
}

.linked-cases-table {
  border-collapse: collapse;
  width: 100%;
  background: #fff;
}
.linked-cases-table th,
.linked-cases-table td {
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #e0e0e0;
  vertical-align: middle;
  min-width: 120px;
}
.linked-cases-table th {
  background: #f5f5f5;
  font-weight: 600;
}
.linked-cases-table td {
  font-size: 1rem;
}

.text-center {
  text-align: center;
}

.text-muted {
  color: #888;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/dispute-resolution/linked-cases/linked-cases.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,yBAAA;EACA,WAAA;EACA,gBAAA;AACF;AACE;;EAEE,qBAAA;EACA,gCAAA;EACA,sBAAA;EACA,gBAAA;AACJ;AAEE;EACE,mBAAA;EACA,gBAAA;AAAJ;AAGE;EACE,eAAA;AADJ;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE,WAAA;AAFF","sourcesContent":[".linked-cases-table-container {\r\n  margin: 2rem 0;\r\n  overflow-x: auto;\r\n}\r\n\r\n.linked-cases-table {\r\n  border-collapse: collapse;\r\n  width: 100%;\r\n  background: #fff;\r\n\r\n  th,\r\n  td {\r\n    padding: 0.75rem 1rem;\r\n    border-bottom: 1px solid #e0e0e0;\r\n    vertical-align: middle;\r\n    min-width: 120px;\r\n  }\r\n\r\n  th {\r\n    background: #f5f5f5;\r\n    font-weight: 600;\r\n  }\r\n\r\n  td {\r\n    font-size: 1rem;\r\n  }\r\n}\r\n\r\n.text-center {\r\n  text-align: center;\r\n}\r\n\r\n.text-muted {\r\n  color: #888;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
